import React, { forwardRef } from 'react';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import MerchantDescriptionBasic from './components/MerchantDescriptionBasic';
import MerchantDescriptionDetailed from './components/MerchantDescriptionDetailed';

import './MerchantDescription.scss';

const MerchantDescription = forwardRef(({ merchant, config }, ref) => {
  const checkShouldShowBasicDescription = (merchant) => {
    const { disclaimerBreakdown = {} } = merchant;
    const { exclusions, limits, specialTerms } = disclaimerBreakdown;
    return isEmpty(exclusions) && isEmpty(limits) && isEmpty(specialTerms);
  };

  const shouldShowBasicDescription = checkShouldShowBasicDescription(merchant);

  return (
    <div className="mn_merchantExperienceDescription" ref={ref}>
      {
        shouldShowBasicDescription
          ? <MerchantDescriptionBasic merchant={merchant} config={config} />
          : <MerchantDescriptionDetailed merchant={merchant} config={config} />
      }
    </div>
  );
});

export default forwardRef((props, ref) => (
  <ComponentErrorBoundary><MerchantDescription {...props} ref={ref} /></ComponentErrorBoundary>
));
